module.exports = __webpack_public_path__ + "img/message-arrow-up.42ed0cd2.svg";